export function SetData(key, data) {
  if (
    (key === "remember" && data === false) ||
    JSON.parse(sessionStorage.getItem("remember")) === false
  ) {
    sessionStorage.setItem(key, JSON.stringify(data));
  } else {
    localStorage.setItem(key, JSON.stringify(data));
  }
}

export function GetData(key) {
  if (JSON.parse(sessionStorage.getItem("remember")) === false) {
    return JSON.parse(sessionStorage.getItem(key));
  } else {
    return JSON.parse(localStorage.getItem(key));
  }
}

export function RemoveData(key) {
  if (JSON.parse(sessionStorage.getItem("remember")) === false) {
    sessionStorage.removeItem(key);
  } else {
    localStorage.removeItem(key);
  }
}
